import { EpisodeState } from "@/api/episodes-types";
import { useTagModalStore } from "@/stores/tag-modal-store";
import { Close } from "@mui/icons-material";
import { Chip } from "@mui/material";

type TagProps = {
  text: string;
  episodeId: string;
  episodeState: EpisodeState | undefined;
  disabled?: boolean;
};

export function Tag({ text, episodeId, episodeState, disabled }: TagProps) {
  const openDeleteModal = useTagModalStore((state) => state.openModal);

  if (!text || text.trim() === "") return null;

  return (
    <Chip
      label={text}
      variant={"outlined"}
      color="primary"
      size="small"
      disabled={disabled}
      sx={{ height: "20px" }}
      deleteIcon={<Close />}
      onDelete={
        episodeState && episodeState !== EpisodeState.rejected
          ? () => openDeleteModal({ name: text, episodeIds: [episodeId] })
          : undefined
      }
    />
  );
}
